import $ from 'jquery';

function getMediaBreakpoint(breakpoint) {
  const value = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(`--breakpoint-${breakpoint}`)
    .trim();
  return value;
}


$('.menu-toggle').on('click', function () {
  var $button = $(this);
  var $header = $('#masthead-inner');
  
  $button.toggleClass('open');
  var $menuContainer = $button.siblings('.menu-primary-container');
  $menuContainer.css('z-index', '99');

  var ariaExpanded = $button.attr('aria-expanded');
  var newAriaExpanded = ariaExpanded === 'true' ? 'false' : 'true';

  $button.attr('aria-expanded', newAriaExpanded);
  $menuContainer.toggleClass('show', newAriaExpanded === 'true');

  if (newAriaExpanded === 'true') {
    $('html').addClass('body-no-scroll');
    
    if ($header.hasClass('sticky')) {
      $header.css('top', '0');
    }
  } else {
    $('html').removeClass('body-no-scroll');
    
    if ($header.hasClass('sticky')) {
      $header.css('top', '');
    }
  }
});


$(window).on('resize', function () {
  var windowWidth = $(window).width();
  var breakpoint = getMediaBreakpoint('lg');
  var $hamburger = $('.menu-toggle');
  var $menuContainer = $('.menu-primary-container');

  if (windowWidth >= parseInt(breakpoint)) {
    $hamburger.removeClass('open');
    $hamburger.attr('aria-expanded', 'false');
    $hamburger.hide();
    $menuContainer.css('z-index', '');
    $menuContainer.removeClass('show');
  } else {
    $hamburger.show();
  }
});

// sticky header
document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('masthead-inner');
  const submenuContainer = document.getElementById('submenu-container');
  const menuUsluge = document.querySelector('.menu-item-usluge'); 
  const sticky = window.innerHeight * 2;
  const content = document.querySelector('#page');
  let headerHeight = header.offsetHeight;

  window.onscroll = function () {
    if (window.pageYOffset > sticky) {
      if (!header.classList.contains('sticky')) {
        header.classList.add('sticky');
        submenuContainer.classList.add('sticky-submenu'); 
        content.style.paddingTop = headerHeight + 'px'; 
      }
    } else {
      if (header.classList.contains('sticky')) {
        header.classList.remove('sticky');
        header.classList.remove('no-border-radius');
        submenuContainer.classList.remove('sticky-submenu'); 
        content.style.paddingTop = '0'; 
      }
    }
  };

  window.addEventListener('resize', function () {
    if (header.classList.contains('sticky')) {
      headerHeight = header.offsetHeight;
      content.style.paddingTop = headerHeight + 'px';
    }
  });

  menuUsluge.addEventListener('mouseover', function () {
    submenuContainer.classList.add('active');
    if (header.classList.contains('sticky')) {
      header.classList.add('no-border-radius');
    }
  });

  submenuContainer.addEventListener('mouseleave', function () {
    submenuContainer.classList.remove('active');
    header.classList.remove('no-border-radius');
  });
});




//submenu usluge
document.addEventListener('DOMContentLoaded', function () {
    const submenuContainer = document.getElementById('submenu-container');
    const menuUsluge = document.querySelector('.menu-item-usluge'); 
    const submenuItems = document.querySelectorAll('.submenu-item');
    const submenuContents = document.querySelectorAll('.submenu-content');

 
    if (submenuItems.length > 0) {
        const initialItem = submenuItems[0];
        const initialCategory = initialItem.getAttribute('data-category');
        

        initialItem.classList.add('active');
        document.getElementById(`${initialCategory}-content`).classList.add('active');
    }

 
    menuUsluge.addEventListener('mouseover', function () {
        submenuContainer.classList.add('active');
    });


    submenuContainer.addEventListener('mouseleave', function () {
        submenuContainer.classList.remove('active');
        

        submenuItems.forEach(item => item.classList.remove('active'));
        submenuContents.forEach(content => content.classList.remove('active'));

        if (submenuItems.length > 0) {
            const initialItem = submenuItems[0];
            const initialCategory = initialItem.getAttribute('data-category');
            initialItem.classList.add('active');
            document.getElementById(`${initialCategory}-content`).classList.add('active');
        }
    });

    submenuItems.forEach(item => {
        item.addEventListener('mouseover', function () {
            submenuItems.forEach(subItem => subItem.classList.remove('active'));
            submenuContents.forEach(content => content.classList.remove('active'));

            item.classList.add('active');
            const category = item.getAttribute('data-category');
            document.getElementById(`${category}-content`).classList.add('active');
        });
    });
});





